import { Maintenance } from '@/modules/Maintenance';
import WpRepository from './client/WpAxiosClient';

/**
 * wordpressメンテナンスAPIリポジトリロジック
 */
export const useMaintenanceRepository = () => {
  /**
   * @doc    wordpressメンテナンスAPIレスポンスを取得する
   * @return Promise<{maintenance: Maintenance[]}>
   */
  const getFromWP = async () => {
    const { data } = await WpRepository.get<{ maintenance: Maintenance }>(`/maintenance`).catch((e) => {
      throw e;
    });
    return data;
  };

  return {
    getFromWP,
  };
};

/**
 * wordpressメンテナンスAPIリポジトリタイプ定義
 */
export type MaintenanceRepository = ReturnType<typeof useMaintenanceRepository>;
